import React from "react";
import { motion } from "framer-motion";
import { STATS } from "@/lib/site";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="surface-band py-12 sm:py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
        {/* Centered Editorial Section Header */}
        <div className="flex flex-col items-center text-center">
          <motion.h2
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-heading max-w-[800px] text-[#222222]"
          >
            A studio that ships. An academy that hires.
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-4 sm:mt-6 text-body-editorial max-w-[640px] text-[#222222]"
          >
            Innovate IT Solutions was founded on a simple principle: the engineers
            building production systems and the apprentices learning to build them
            should sit at the exact same desks. Everything we teach is something
            we actively deploy.
          </motion.p>
        </div>

        {/* Media Block (Documentary photo): 1200px max-width, 12px radius */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-10 sm:mt-12 md:mt-16"
        >
          <figure className="media-frame relative aspect-[16/10] sm:aspect-[16/9] md:aspect-[21/9] w-full">
            <img
              src="https://images.unsplash.com/photo-1522881193457-37ae97c905bf?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=2400&q=80"
              alt="Mentor and trainee reviewing architecture code"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </figure>
        </motion.div>

        {/* Stats Row in flat achromatic style */}
        <div className="mt-10 sm:mt-14 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8 text-center border-t border-[#ebebeb] pt-8 sm:pt-12">
          {STATS.map((s, i) => (
            <motion.div
              key={s.k}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="px-2"
            >
              <p className="text-[32px] sm:text-[40px] md:text-[50px] font-medium leading-none tracking-tight text-[#222222]">
                {s.k}
              </p>
              <p className="mt-2 text-[13px] sm:text-[14px] text-[#6a6a6a] font-normal">
                {s.v}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
